/* global sessionStorage */

export default function setUpTradePage () {
  setupRegistrationButtons()
}

function setupRegistrationButtons () {
  const container = document.getElementById('vjs-trade-apply-container')
  if (!container) return

  const email = container.dataset.email
  const path = email ? `/authorize/trade_buyer?email=${encodeURIComponent(email)}` : '/authorize'

  const btns = document.getElementsByClassName('vjs-trade-apply-btn')
  Array.from(btns).forEach((element) => {
    element.addEventListener('click', () => {
      sessionStorage.setItem('trade_sign_up', 'true')
      window.location.href = path
    })
  })
}
